import env from '@eneco/common/env';

export const host = env('SITECORE_API_HOST');
export const host_csr = env('SITECORE_API_HOST_CSR');
export const key = env('SITECORE_API_KEY');
export const site = env('SITECORE_API_SITE');
export const jss = env('SITECORE_LAYOUT_SERVICE_ROUTE');
export const jssPlaceholder = env('SITECORE_LAYOUT_PLACEHOLDER_ROUTE');
